import React from 'react';
import { CustomError } from "./CustomError";

export const CustomInputField = ({ ...props }) => {
  const {
    idSchema,
    required,
    disabled,
    readonly,
    autofocus,
    onChange,
    onBlur,
    schema,
    uiSchema,
    formData,
  } = props;

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  const handleBlur = (event) => {
    onBlur(idSchema.$id, event.target.value);
  };

  return (
    <div className={"custom-field"}>
      {schema.title && <label className={"control-label"} htmlFor={idSchema.$id}>{schema.title}</label>}
      <input
        id={idSchema.$id}
        name={idSchema.$id}
        className={"form-control"}
        label={schema.title}
        required={required}
        disabled={disabled}
        readOnly={readonly}
        autoFocus={autofocus}
        value={formData}
        onChange={handleChange}
        onBlur={handleBlur}
        type={"text"}
        maxLength={schema["maxLength"]}
        placeholder={uiSchema["ui:placeholder"]}
      />
      <p className={"extra-text"}>{uiSchema["ui:description"]}</p>
      <CustomError schema={schema} uiSchema={uiSchema}/>
    </div>
  );
};
